export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YMptilQs6yLUrwB0lw.dd85c319.woff2";